export default __webpack_public_path__ + "static/media/Screenshot_16.afaf0311.png";